import { MutationTree } from 'vuex';
import BookingState from '@/types/store/booking/BookingState';
import CommuneProjection from '@/types/projections/CommuneProjection';
import Booking from '@/types/taxcard/Booking';
import BookingPriceProjection from '@/types/projections/BookingPriceProjection';
import AccommodationProjection from '@/types/projections/AccommodationProjection';
import moment from 'moment';
import BIObject from '@/types/taxcard/BIObject';

function canBookingSessionBeStored(booking: Booking) {
  if (booking && booking.bIObjects.length > 0) {
    const bIObject: BIObject = booking.bIObjects[0];
    const result =
      bIObject.bIObjectData.addressCity !== '' ||
      bIObject.bIObjectData.addressStreetAndNumber !== '' ||
      bIObject.bIObjectData.addressZipCode !== '' ||
      bIObject.bIObjectData.annualCardKey !== '' ||
      bIObject.bIObjectData.annualCardPhoto !== '' ||
      bIObject.bIObjectData.birthday !== null ||
      bIObject.bIObjectData.cellphoneNumber !== '' ||
      bIObject.bIObjectData.email !== '' ||
      bIObject.bIObjectData.firstName !== '' ||
      bIObject.bIObjectData.lastName !== '' ||
      bIObject.bIObjectData.salutation !== '' ||
      bIObject.bIObjectData.title !== '';
    return result;
  }
  return false;
}

const mutations: MutationTree<BookingState> = {
  setCommunes(state, communes: CommuneProjection[]): void {
    state.communes = communes;
  },
  setCurrentBooking(state, booking: Booking | null): void {
    state.currentBooking = booking;
    window.localStorage.setItem('currentBooking', booking ? booking.dehydrate() : JSON.stringify(null));
    const now = moment().valueOf();

    //Detect if the current booking has data or not to create a current session
    if (booking && canBookingSessionBeStored(booking)) {
      state.currentBookingSession = now;
      window.localStorage.setItem('currentBookingSession', JSON.stringify(now));
    } else {
      state.currentBookingSession = null;
      window.localStorage.setItem('currentBookingSession', JSON.stringify(null));
    }
  },
  setCurrentPriceProjection(state, prices: BookingPriceProjection | null): void {
    state.currentPriceProjection = prices;
    window.localStorage.setItem('currentPriceProjection', JSON.stringify(prices));
  },
  setCurrentOrderId(state, orderId: string | null): void {
    state.currentOrderId = orderId;
    window.localStorage.setItem('currentOrderId', JSON.stringify(orderId));
  },
  setAccommodations(state, accommodations: AccommodationProjection[]): void {
    state.accommodations = accommodations;
  },
  setCurrentPaymentMethod(state, paymentMethod: string | null): void {
    state.currentPaymentMethod = paymentMethod;
  },
  setCurrentBookingToCheckoutView(state, booking: Booking): void {
    state.currentBooking = booking;
    booking.bIObjects = booking.bIObjects.map((t: BIObject) => {
      if (t.bIObjectData.isAnnual) {
        t.bIObjectData.stayBegin = moment(t.bIObjectData.stayBegin).startOf('year');
      }
      return t;
    });
    window.localStorage.setItem('currentBooking', booking ? booking.dehydrate() : JSON.stringify(null));
    const now = moment().valueOf();

    //Detect if the current booking has data or not to create a current session
    if (booking && canBookingSessionBeStored(booking)) {
      state.currentBookingSession = now;
      window.localStorage.setItem('currentBookingSession', JSON.stringify(now));
    } else {
      state.currentBookingSession = null;
      window.localStorage.setItem('currentBookingSession', JSON.stringify(null));
    }
  },
};

export default mutations;
